import React, {useEffect, useState} from "react"
import {useHelp, useModal, useRoomSetup, useSolution, useLocal, useProgress, useRoomParameters, useMessage, useCatalog, useLightbox, useUrlQueryComponent} from "../AppContext"
import {hasUrlFlag, URL_FLAG__LIGHTVERSION} from "../Helper/UrlFlag"
import {useSidebar} from "../Hooks/Sidebar"
import {useRename} from "../Hooks/Rename"
import {ButtonShy} from "../Components/Button"
import {MenuLeft} from "../Components/MenuLeft"
import {ItemOptions} from "./Solution/ItemOptions"
import {ItemQuantity} from "./Solution/ItemQuantity"
import {ItemRemove} from "./Solution/ItemRemove"
import {SideBarRightBody2Rows, SideBarRightHead, SideBarRightHeadItem, SideBarRightInfo, SideBarRightLayout} from "../Components/SideBar/SideBarRight"
import {SideBarRightHandel} from "../Components/SideBar/SideBarRightHandel"
import {ItemSwap} from "./Solution/ItemSwap"
import {InputText} from "../Components/Input"
import {SolutionIntroVideo} from "../Components/SolutionIntroVideo"
import {pager} from "../Hooks/SuggestedSolutions"
import {ExitIntent} from "../Modal/ExitIntent"
import {iconChange, iconCopy, iconRemove, iconRotatePlus, iconSettings, iconEdit, iconCrown, iconSave, iconBin, icon3D, iconClose, iconCheckmark2, iconUndo, iconCheckmark3, iconGallery} from "../Helper/Icons"
import style from "./Solution.css"

export const Solution = ({setProduct}) => {
    const help = useHelp()
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const solution = useSolution()
    const urlQueryComponent = useUrlQueryComponent()
    

    useEffect(() => {
        help.setContext("vorschlaege")
        if (!roomSetup.getId()) {
            roomSetup.save()
            pager().resetPage()
        } else {
            solution.setRoomId(roomSetup.getId())
        }
    }, [roomSetup.getId()])

    const isPremiumTagged = !urlQueryComponent.isContentDisplayed('requestQuote')
    const lightversion = hasUrlFlag(URL_FLAG__LIGHTVERSION)
    
    if (lightversion){
      return <>
        <MenuLeft label={local.__("Ihre Entwürfe")}>
            <div className={style.layout}>
                
                <div className={style.suggestions}>
                    {solution.getSolutionList().map((planning, index) => <SolutionMenuItem key={planning.index} planning={planning} count={index + 1}/>)}
                </div>
                {isPremiumTagged && <Annotation/>}
                <SolutionSuggestions/>
            </div>
        </MenuLeft>
        <Properties setProduct={setProduct}/>
        <SolutionIntroVideo/>
        <ExitIntent/>
    </>
    
    
    
    }
    
    return <>
        <MenuLeft label={local.__("Empfehlungshilfe")}>
            <div className={style.layout}>
                <Recommendation/>
                <Cta/>
                <div className={style.suggestions}>
                    {solution.getSolutionList().map((planning, index) => <SolutionMenuItem key={planning.index} planning={planning} count={index + 1}/>)}
                </div>
                {isPremiumTagged && <Annotation/>}
                <SolutionSuggestions/>
            </div>
        </MenuLeft>
        <Properties setProduct={setProduct}/>
        <SolutionIntroVideo/>
        <ExitIntent/>
    </>
}

const Recommendation = () => {
    return <div className={style.recommendation}>
        <Budget/>
        <FireProtectionClass/>
    </div>
}

const Cta = () => {
    const local = useLocal()
    return <div className={style.cta}>
        <div className={style.title}>{local.__("Entwürfe")}</div>
    </div>
}

const Annotation = () => {
    const local = useLocal()
    return <div className={style.annotation}>
        <div>{iconCrown}</div>
        <div>{local.__("Set enthält Premium-Artikel ...")}</div>
    </div>
}

const Budget = () => {
    const local = useLocal()
    const progress = useProgress()
    const roomSetup = useRoomSetup()

    const option = roomSetup.getBudget()
        ? local.currencyPlain(roomSetup.getBudget())
        : local.__("offen")

    return <>
        <div className={style.label}>{local.__("Preisfenster")}</div>
        <div>{option}</div>
        <div className={style.action} onClick={() => progress.gotoConditions()}>{iconEdit}</div>
    </>
}

const FireProtectionClass = () => {
    const local = useLocal()
    const progress = useProgress()
    const roomSetup = useRoomSetup()
    const roomParameters = useRoomParameters()

    const option = roomSetup.getFireProtectionClass() === "none"
        ? local.__("ohne")
        : local.getLabel(roomParameters.getFireProtectionClasses().find(fireProtectionClass => fireProtectionClass.code === roomSetup.getFireProtectionClass()).name)


    return <>
        <div className={style.label}>{local.__("Brandschutz")}</div>
        <div>{option}</div>
        <div className={style.action} onClick={() => progress.gotoConditions()}>{iconEdit}</div>
    </>
}

const SolutionMenuItem = ({planning, count}) => {
    const local = useLocal()
    const message = useMessage()
    const modal = useModal()
    const rename = useRename()
    const solution = useSolution()
    const urlQueryComponent = useUrlQueryComponent()

    const select = () => {
        solution.setCurrentSolutionIndex(planning.index)
    }

    const reset = (event) => {
        const reset = () => {
            event.stopPropagation()
            solution.resetCurrentSolution()
        }
        message.showPrompt(local.__("Möchten Sie die Planung zurücksetzen?"), reset)
    }

    const remove = (event) => {
        const remove = () => {
            event.stopPropagation()
            solution.removeCurrentSolution()
        }
        message.showPrompt(local.__("Möchten Sie die Planung löschen?"), remove)
    }

    const isRequestQuoteDisplayed = urlQueryComponent.isContentDisplayed('requestQuote')
    const reviewButtonLabel = isRequestQuoteDisplayed ? 'Angebot anfordern' : 'Planung abschließen'
    const review = () => {
        if (isRequestQuoteDisplayed) {
            modal.openRequestQuote()
        } else {
            modal.openSolutionReview()
        }
    }

    const save = async (event) => {
        event.stopPropagation()
        modal.openSolutionSave()
    }

    const editName = () => {
        rename.start(planning.name)
    }

    const applyName = () => {
        solution.setPlanningName(rename.getValue())
        rename.stop()
    }

    const isPremiumTagged = !urlQueryComponent.isContentDisplayed('requestQuote')

    if (planning.isActive) {
        return <div className={style.itemActive}>
            <div>
                <div className={style.icon}>{icon3D}</div>
            </div>
            <div>
                <div className={style.count}>
                    <div>{local.__("Entwurf")} {count}</div>
                    {planning.isPremium && isPremiumTagged && <div className={style.premium}>{iconCrown}</div>}
                </div>
                <div className={style.name}>{planning.name}</div>
                {!rename.isEdit() && <div className={style.actions}>
                    <div onClick={editName} title={local.__("Umbenennen")}>{iconEdit}</div>
                    <div onClick={save} title={local.__("Speichern")}>{iconSave}</div>
                    <div onClick={reset} title={local.__("Zurücksetzen")}>{iconUndo}</div>
                    <div onClick={remove} title={local.__("Entfernen")}>{iconBin}</div>
                    <div onClick={review} title={local.__(reviewButtonLabel)}>{iconCheckmark3}</div>
                </div>}
                {rename.isEdit() && <div className={style.rename}>
                    <InputText value={rename.getValue()} onChange={rename.setValue} size={1}/>
                    <div onClick={applyName}>{iconCheckmark2}</div>
                    <div onClick={rename.stop}>{iconClose}</div>
                </div>}
            </div>
        </div>
    }

    return <div onClick={select} className={style.item}>
        <div>
            <div className={style.icon}>{icon3D}</div>
        </div>
        <div>
            <div className={style.count}>
                <div>{local.__("Entwurf")} {count}</div>
                {planning.isPremium && isPremiumTagged && <div className={style.premium}>{iconCrown}</div>}
            </div>
            <div className={style.name}>{planning.name}</div>
        </div>
    </div>

}

const SolutionSuggestions = () => {
    const modal = useModal()
    const roomSetup = useRoomSetup()
    const solution = useSolution()
    const local = useLocal()
    const add = solution.countSolution() > 0

    const openAdditionalSolutionSuggestions = () => {
        modal.openAdditionalSolutionSuggestions()
    }

    const openSolutionSuggestions = () => {
        modal.openSolutionSuggestions()
    }

    useEffect(() => {
        if (roomSetup.getId() && solution.countSolution() === 0) {
            openSolutionSuggestions()
        }
    }, [roomSetup.getId(), solution.countSolution()])

    return <div className={style.load}>
        {add && <ButtonShy onClick={openAdditionalSolutionSuggestions}>{local.__("Weitere Vorschläge laden")}</ButtonShy>}
        {!add && <ButtonShy onClick={openSolutionSuggestions}>{local.__("Vorschläge Laden")}</ButtonShy>}
    </div>
}

const Properties = ({setProduct}) => {
    const SECTION_EDIT = 1
    const SECTION_COPY = 2
    const SECTION_CHANGE = 3
    const SECTION_REMOVE = 4

    const sidebar = useSidebar(true, true)
    const roomSetup = useRoomSetup()
    const local = useLocal()
    const solution = useSolution()
    const catalog = useCatalog()
    const [section, setSection] = useState(SECTION_EDIT)
    const lightbox = useLightbox()

    const setSectionEdit = () => {
        setSection(SECTION_EDIT)
        sidebar.open()
    }

    const setSectionCopy = () => {
        setSection(SECTION_COPY)
        sidebar.open()
    }

    const setSectionChange = () => {
        setSection(SECTION_CHANGE)
        sidebar.open()
    }

    const setSectionRemove = () => {
        setSection(SECTION_REMOVE)
        sidebar.open()
    }

    const setSectionRotate = () => {
        sidebar.open()
    }

    const rotateItemWireDuo = () => {
        solution.itemRotateWireDuo()
    }

    const rotateItemRegular = () => {
        solution.itemRotateRegular()
    }

    const isSectionEdit = () => {
        return solution.getItem() && section === SECTION_EDIT
    }

    const isSectionCopy = () => {
        return solution.getItem() && section === SECTION_COPY
    }

    const isSectionChange = () => {
        return solution.getItem() && section === SECTION_CHANGE
    }

    const isSectionRemove = () => {
        return solution.getItem() && section === SECTION_REMOVE
    }

    const isWireDuo40MountingSurfaceType = () => {
        return solution.isWireDuo40MountingSurfaceType()
    }

    useEffect(() => {
        if (solution.getItem()) {
            sidebar.enable()
        } else {
            sidebar.disable()
            setSection(SECTION_EDIT)
        }
    }, [solution.getItem()])

    sidebar.onToggleCallback(() => solution.handlerUnset())

    return <SideBarRightHandel sidebar={sidebar}>
        <SideBarRightLayout>
            <SideBarRightHead>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} isActive={isSectionEdit()} icon={iconSettings} label={local.__("Absorber bearbeten")} onClick={setSectionEdit}/>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} isActive={isSectionCopy()} icon={iconCopy} label={local.__("Absorber duplizieren")} onClick={setSectionCopy}/>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} isActive={isSectionChange()} icon={iconChange} label={local.__("Absorber tauschen")} onClick={setSectionChange}/>
                <SideBarRightHeadItem isDisabled={sidebar.isDisable()} isActive={isSectionRemove()} icon={iconRemove} label={local.__("Absorber löschen")} onClick={setSectionRemove}/>
                {!isWireDuo40MountingSurfaceType() && <SideBarRightHeadItem isDisabled={sidebar.isDisable()} isActive={isSectionRemove()} icon={iconRotatePlus} label={local.__("Drehen")} onClick={rotateItemRegular}/>}
                {isWireDuo40MountingSurfaceType() && <SideBarRightHeadItem icon={iconRotatePlus} label={local.__("Drehen")} onClick={rotateItemWireDuo}/>}
                {sidebar.isOpen() && solution.getItem() && <SideBarRightInfo>
                    <div>{local.__("Ausgewählter Absorber:")}</div>
                    <div className={style.sideBarRightInfoValue} onClick={() => {setProduct(catalog.getParentProduct(solution.getItem().parentSku)); lightbox.openGallery();}}>
                        <span className={style.name}>{catalog.getParentProduct(solution.getItem().parentSku)?.name}</span>
                        <span className={style.icon}>{iconGallery}</span>
                    </div>
                </SideBarRightInfo>}
            </SideBarRightHead>
            <SideBarRightBody2Rows isOpen={sidebar.isOpen()} key={roomSetup.getHandle()}>
                {isSectionEdit() && <ItemOptions/>}
                {isSectionCopy() && <ItemQuantity/>}
                {isSectionChange() && <ItemSwap/>}
                {isSectionRemove() && <ItemRemove/>}
            </SideBarRightBody2Rows>
        </SideBarRightLayout>
    </SideBarRightHandel>
}
